import {
  CalendarDays,
  CreditCard,
  Gift,
  MenuSquare,
  MessageSquare,
  Package,
  Settings,
  Shield,
  ShoppingBag,
  TicketPercent,
  Truck,
  Users,
} from "lucide-react";

export const categoryOptions = [
  "orders",
  "payments",
  "customers",
  "inventory",
  "delivery",
  "messages",
  "coupons",
  "specials",
  "calendar",
  "menu",
  "system",
  "security",
];

export const severityOptions = ["info", "success", "warning", "danger"];

export const categoryMeta = {
  orders: { icon: ShoppingBag, label: "Orders" },
  payments: { icon: CreditCard, label: "Payments" },
  customers: { icon: Users, label: "Customers" },
  inventory: { icon: Package, label: "Inventory" },
  delivery: { icon: Truck, label: "Delivery" },
  messages: { icon: MessageSquare, label: "Messages" },
  coupons: { icon: TicketPercent, label: "Coupons" },
  specials: { icon: Gift, label: "Specials" },
  calendar: { icon: CalendarDays, label: "Calendar" },
  menu: { icon: MenuSquare, label: "Menu" },
  system: { icon: Settings, label: "System" },
  security: { icon: Shield, label: "Security" },
};

export function label(value) {
  return String(value || "")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (match) => match.toUpperCase());
}

export function timeAgo(value) {
  const created = new Date(value).getTime();
  if (Number.isNaN(created)) return "Unknown time";

  const seconds = Math.max(1, Math.round((Date.now() - created) / 1000));
  if (seconds < 60) return `${seconds}s ago`;

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  return new Date(value).toLocaleDateString();
}

export function groupKey(value) {
  const date = new Date(value);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";

  return date.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}